import './PaperlessPreferencesOverview.scss'

import React from 'react'
import GoPaperlessView from './GoPaperlessView'
import PaperlessPreferencesIndicatorView from './PaperlessPreferencesIndicatorView'

const PaperlessPreferencesOverview = (props) => {
  return (
    <div className="paperless-overview-section beacon-on-darker">
      <GoPaperlessView {...props}/>
      <PaperlessPreferencesIndicatorView paperlessPreferencesStatus={props.paperlessPreferencesStatus}/>
    </div>
  );
}

export default PaperlessPreferencesOverview